import {
  KYCStatus,
  ReceivableStatus,
  VirtualAccountStatus
} from "../../../services/authService/AuthService.type";

import pendingImg from "../../../assets/status-pending.svg";
import approvedImg from "../../../assets/status-approved.svg";
import onHoldImg from "../../../assets/status-onHold.svg";
import rejectedImg from "../../../assets/status-rejected.svg";
import receivablesUpdatedImg from "../../../assets/status-updated.svg";
import notInitiatedImg from "../../../assets/status-not-init.svg";

export const statusCardContents = {
  labels: {
    status: "Status",
    kyc: "KYC Document",
    accountCreation: "Account Creation",
    receivables: "Receivables Confirmation",
    pending: "Pending",
    approved: "Approved",
    onHold: "On Hold",
    rejected: "Rejected",
    inVerification: "In Verification",
    acceptedJitfin: "Accepted by JitFin",
    rejectedJitfin: "Rejected by JitFin",
    acceptedProspect: "Accepted by Prospect",
    rejectedProspect: "Rejected by Prospect",
    awaitingAcceptance: "Awaiting Acceptance",
    updatedEligibilityAmount: "Updated Eligibility Amount is ",
    receivableAmount: "Total receivables for next 4 months is ",
    updatedReceivables: "Receivables",
    receivablesCustomer: " towards customer ",
    notInitiated: "Not Initiated"
  },
  buttons: {
    reUploadKyc: "Re-Upload KYC",
    accountCreation: "Upload here",
    accept: "Accept",
    reject: "Reject",
    view: "View"
  },
  feedback: {
    success: (isAccepted: boolean) =>
      `Successfully ${
        isAccepted ? "accepted" : "rejected"
      } the Eligibility amount`,
    fileUpload: "Successfully uploaded file."
  }
};

const imageAndLabelFromSubstatus = {
  [KYCStatus.KYCPending]: [pendingImg, statusCardContents.labels.pending],
  [KYCStatus.KYCOnHold]: [onHoldImg, statusCardContents.labels.onHold],
  [KYCStatus.KYCApproved]: [approvedImg, statusCardContents.labels.approved],
  [KYCStatus.KYCRejected]: [rejectedImg, statusCardContents.labels.rejected],
  [VirtualAccountStatus.Accepted]: [
    approvedImg,
    statusCardContents.labels.approved
  ],
  [VirtualAccountStatus.UploadPending]: [
    pendingImg,
    statusCardContents.labels.pending
  ],
  [VirtualAccountStatus.InVerification]: [
    pendingImg,
    statusCardContents.labels.inVerification
  ],
  [VirtualAccountStatus.Rejected]: [
    rejectedImg,
    statusCardContents.labels.rejected
  ],
  [ReceivableStatus.AcceptedByJitfin]: [
    approvedImg,
    statusCardContents.labels.acceptedJitfin
  ],
  [ReceivableStatus.AcceptedByProspect]: [
    approvedImg,
    statusCardContents.labels.acceptedProspect
  ],
  [ReceivableStatus.RejectedByJitfin]: [
    rejectedImg,
    statusCardContents.labels.rejectedJitfin
  ],
  [ReceivableStatus.RejectedByProspect]: [
    rejectedImg,
    statusCardContents.labels.rejectedProspect
  ],
  [ReceivableStatus.PendingVerification]: [
    pendingImg,
    statusCardContents.labels.inVerification
  ],
  [ReceivableStatus.AwaitingAcceptance]: [
    receivablesUpdatedImg,
    statusCardContents.labels.awaitingAcceptance
  ]
};

export const getImageAndLabel = (
  substatusKey: KYCStatus | VirtualAccountStatus | ReceivableStatus | null
) => {
  if (!substatusKey) {
    return [notInitiatedImg, statusCardContents.labels.notInitiated];
  }
  return imageAndLabelFromSubstatus[substatusKey];
};
